"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ButtonGroup = void 0;

var _preact = require("preact");

var ButtonGroup = function ButtonGroup(_ref) {
  var children = _ref.children,
      _ref$direction = _ref.direction,
      direction = _ref$direction === void 0 ? 'horizontal' : _ref$direction;
  return (0, _preact.h)("div", {
    className: "m-button m-button--".concat(direction)
  }, children);
};

exports.ButtonGroup = ButtonGroup;